module.exports = __webpack_public_path__ + "static/media/Slack-2.19af81fd.jpg";